import {memoize, values, nthArg, camelCase, get, groupBy, map, pick, size, includes, createSelector, createStructuredSelector} from 'vendor';
import {today, date} from 'store/common';
import {matchesRepetition} from './matches-repetition';
import {dayRecords, weekRecords, monthCompletedRecords} from './progress';
import {status} from 'store/activities/selectors/status';
import {subroutinesById} from 'store/activities/selectors/activities';

const statuses = {
  disabled: false,
  missed: { status: 'Missed' },
  notScheduled: undefined,
  scheduled: { status: 'Not Started' },
}

export const occurance = createSelector(
  [today, date, subroutinesById, matchesRepetition, dayRecords, weekRecords, monthCompletedRecords ],
  (today, date, subroutinesById, matchesRepetition, dayRecords, weekRecords, monthCompletedRecords ) => {

    // console.log('create occurance', date.format())
    const getOccurance = memoize(activity => {
      // console.log('get for', activity.name, date.format())
      if (!activity.repeatType) {
        if (activity.status == 'Not Started' && activity.ts && activity.ts < today.unix()) {
          return statuses.missed;
        }
        return activity.ts == date.unix() ? pick(activity, 'status') : statuses.notScheduled;
      }

      const record = dayRecords && dayRecords[activity.id];

      if (get(record, 'status') == 'Rescheduled') {
        return statuses.notScheduled;
      }

      if (record) {
        return {
          ...record,
          status: (record.status || 'Not Started').replace('Not Started', date.isBefore(today) ? 'Missed' : 'Not Started'),
        }
      }

      if (/On Hold|Expired|Future/.test(status(activity, date.unix()))) {
        return statuses.disabled;
      }

      if (!matchesRepetition(activity)) {
        return statuses.notScheduled;
      }

      //@todo fix?
      // if (activity.repeatType == 'Monthly' && monthCompletedRecords.indexOf(activity.id) != -1) {
      //   return statuses.notScheduled;
      // } else
      if (activity.repeatType == 'PerWeek') {
        const { missed, scheduled } = getStats(weekRecords, today, activity);
        if (!includes(missed, date.unix()) && !includes(scheduled, date.unix())) {
          return statuses.notScheduled;
        }
      }

      if (activity.dailyRoutineType == 'daily_routine' && subroutinesById[activity.id]) {
        const subroutinesStatus = groupBy(subroutinesById[activity.id].map(getOccurance), 'status');
        const hasStatuses = subroutinesById[activity.id].filter(e => get(getOccurance(e), 'status') != 'Not Started');
        const first = get(values(subroutinesStatus), '0.0');
        if (size(subroutinesStatus) == 1 && first) {
          return first;
        } else if (size(hasStatuses) == size(subroutinesById[activity.id])) {
          return { status: 'Completed' };
        }
      }

      return date.isBefore(today) ? statuses.missed : statuses.scheduled;
    });

    return getOccurance;

  },
  { memoizeOptions: { maxSize: 1000 } },
);

const getStats = createSelector(
  [ createSelector(nthArg(0), JSON.parse), nthArg(1), nthArg(2) ],
  ( week, today, activity ) => {
    const { available = [], past = [], completed, missed, skipped, notStarted } = groupBy(week, ({ timestamp, statuses }) => {
      if (statuses && statuses[activity.id]) {
        return camelCase(statuses[activity.id]);
      }
      return timestamp >= today.unix() ? 'available' : 'past';
    });
    const totalToComplete = activity.repeatCount - size(completed) - size(missed) - size(skipped) - size(notStarted);
    const scheduled = available.slice(0, totalToComplete).map(item => item.timestamp);
    return {
      scheduled,
      missed: map(totalToComplete > scheduled.length && past.reverse().slice(0, totalToComplete - scheduled.length), item => item.timestamp),
    }
  },
  { memoizeOptions: { maxSize: 100 } },
);

occurance.dependencies = createStructuredSelector({
  session: state => state.session,
  activities: state => state.activities,
  googleCalendar: state => state.googleCalendar,
});
